<template>
  <div id="verification-question-filter">
    <div class="panel panel-default border-panel card-view">
      <div class="panel-body">
        <div class="row center-row">
          <div class="col-sm-4 ml-30 mr-20">
            <div class="row mb-15">
              <base-dropdown
                :list="categoryList"
                v-model="criteriaCategoryId"
                labelClassNames="control-label mb-10 text-left"
                :labelValue="$t('app.base_states.category')"
                @input="categoryChanged"
              />
            </div>
            <div class="row">
              <base-dropdown
                :list="subCategoryList"
                v-model="subCriteriaCategoryId"
                labelClassNames="control-label mb-10 text-left"
                :labelValue="$t('app.base_states.vice_category')"
                @input="categoryChanged"
              />
            </div>
          </div>
          <div class="col-sm-4 ml-20 mr-60">
            <label>{{$t('app.base_states.filters')}}</label>
            <div class="row mb-20 mt-15">
              <base-checkbox
                :id="'2'"
                :labelValue="$t('app.base_states.legal_reference_only')"
                :value="isSelected(2)"
                @valueChanged="filterChanged(2)"
              />
            </div>
            <div class="row mb-20 mt-15">
              <base-checkbox
                :id="'1'"
                :labelValue="$t('app.base_states.except_legal_reference')"
                :value="isSelected(1)"
                @valueChanged="filterChanged(1)"
              />
            </div>
            <div class="row mb-20 mt-15">
              <base-checkbox
                :id="'0'"
                :labelValue="$t('app.base_states.all_question')"
                :value="isSelected(0)"
                @valueChanged="filterChanged(0)"
              />
            </div>
          </div>
          <div class="cold-sm-4 ml-60 mr-20 pull-right">
            <div class="row">
              <base-button
                :title="$t(`app.base_states.fetch_questions`)"
                :classNames="`btn btn-orange rounded`"
                @clicked="filterQuestions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BaseDropdown from "@/components/shared/inputs/BaseDropDown";
import BaseButton from "@/components/shared/buttons/BaseButton";
import BaseCheckbox from "../../shared/inputs/BaseCheckbox";

export default {
  name: "VerificationQuestionFilter",
  components: {
    "base-button": BaseButton,
    "base-dropdown": BaseDropdown,
    "base-checkbox": BaseCheckbox
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      criteriaCategoryId: undefined,
      subCriteriaCategoryId: undefined,
      selectedFilterIndex: 0
    };
  },
  computed: {
    ...mapGetters({
      commonData: "partners/commonData"
    }),
    categoryList() {
      if (!this.commonData) {
        return [];
      }

      const result = this.commonData.criteria_category_list
        .filter(x => x.parent_id == null)
        .map(x => {
          return { text: x.name, value: x.id };
        });
      return result;
    },
    subCategoryList() {
      if (!this.commonData || !this.criteriaCategoryId) {
        return [];
      }
      return this.commonData.criteria_category_list
        .filter(x => x.parent_id == this.criteriaCategoryId)
        .map(x => {
          return { text: x.name, value: x.id };
        });
    }
  },
  created() {},
  methods: {
    categoryChanged() {
      this.$emit('categoryChanged');
    },
    isSelected(index) {
      return this.selectedFilterIndex == index;
    },
    filterChanged(index) {
      this.$emit('categoryChanged');
      this.selectedFilterIndex = index;
    },
    filterQuestions() {
      this.$emit("filter", {
        categoryId: this.subCriteriaCategoryId
          ? this.subCriteriaCategoryId
          : this.criteriaCategoryId,
        legalReferenceFilter: this.selectedFilterIndex,
        isEdit: this.isEdit
      });
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/VerficiationQuestionFilter.vue